import type { CSSProperties } from "react";
import { COLORS, MOTION, RADIUS, SPACE, TYPE } from "../theme/index.js";

type TabItem = { id: string; label: string; count?: number };

type TabsProps = {
  tabs: TabItem[];
  activeId: string;
  onChange: (id: string) => void;
  style?: CSSProperties;
};

export function Tabs({ tabs, activeId, onChange, style }: TabsProps) {
  return (
    <div
      role="tablist"
      style={{
        display: "flex",
        gap: SPACE[1],
        borderBottom: `1px solid ${COLORS.border}`,
        ...style,
      }}
    >
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            type="button"
            style={{
              padding: `${SPACE[2]}px ${SPACE[3]}px`,
              borderBottom: active ? `2px solid ${COLORS.brand}` : "2px solid transparent",
              background: "none",
              border: "none",
              borderLeft: "none",
              borderRight: "none",
              borderTop: "none",
              color: active ? COLORS.brandText : COLORS.textMuted,
              fontSize: TYPE.size.md,
              fontWeight: active ? TYPE.weight.medium : TYPE.weight.normal,
              cursor: "pointer",
              transition: `color ${MOTION.fast} ${MOTION.ease}`,
              fontFamily: TYPE.family.sans,
              marginBottom: -1,
            }}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span
                style={{
                  marginLeft: SPACE[1],
                  fontSize: TYPE.size.xs,
                  background: COLORS.surface,
                  borderRadius: RADIUS.full,
                  padding: `1px ${SPACE[1]}px`,
                  color: COLORS.textDim,
                }}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
